import script from "./AppReloadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppReloadModal.vue?vue&type=script&setup=true&lang=js"

import "./AppReloadModal.vue?vue&type=style&index=0&id=165a2824&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165a2824"]])

export default __exports__